document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile menu ----
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      const isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      hamburger.setAttribute('aria-expanded', String(!isOpen));
      hamburger.classList.toggle('is-open', !isOpen);
    });
  }

  // ---- Product image thumbnails ----
  const mainImg = document.getElementById('product-main-img');
  const thumbs = document.querySelectorAll('.product-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = this.dataset.src;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  // ---- Add to cart (AJAX) ----
  const productForm = document.getElementById('product-form');
  const addToCartBtn = document.getElementById('add-to-cart');
  if (productForm && addToCartBtn) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(productForm);
      const data = { id: formData.get('id'), quantity: 1 };
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
        });
    });
  }

  // ---- Cart: qty buttons ----
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      const action = this.dataset.action;
      const valueEl = this.parentElement.querySelector('.qty-value');
      let qty = parseInt(valueEl.textContent, 10);
      qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function () { window.location.reload(); })
        .catch(function (err) { console.error(err); });
    });
  });

  // ---- Cart: remove items ----
  document.querySelectorAll('.cart-item__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function () { window.location.reload(); })
        .catch(function (err) { console.error(err); });
    });
  });

});
